var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgChat(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 68,
    height: 68,
    viewBox: "0 0 68 68",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "chat",
    d: "M34,68A34.009,34.009,0,0,1,20.766,2.672,34.009,34.009,0,0,1,47.235,65.328,33.787,33.787,0,0,1,34,68Zm.008-53C22.976,15,14,23.038,14,32.918A16.853,16.853,0,0,0,18.589,44.34a7.388,7.388,0,0,1-.063,3.67A7.288,7.288,0,0,1,16.7,51.185a1.187,1.187,0,0,0-.25,1.312,1.158,1.158,0,0,0,1.081.727,12.713,12.713,0,0,0,4.851-.96,12.88,12.88,0,0,0,4.137-2.724,22.294,22.294,0,0,0,15.293-.114,20.565,20.565,0,0,0,6.414-3.843,18.021,18.021,0,0,0,4.346-5.7,15.978,15.978,0,0,0,0-13.936,18.021,18.021,0,0,0-4.346-5.7,20.565,20.565,0,0,0-6.414-3.843A22.037,22.037,0,0,0,34.008,15Z",
    fill: "#4a90e2"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChat);
export default __webpack_public_path__ + "static/media/chat.fd564ec3.svg";
export { ForwardRef as ReactComponent };